/**
 * Generic poll loop for fire-and-forget async work.
 */

export interface PollOptions<T> {
  fetchSnapshot: () => Promise<T>;
  hasChanged: (snapshot: T) => boolean;
  intervalMs?: number;
  timeoutMs?: number;
  initialSnapshot?: T;
}

export async function pollUntilChange<T>(opts: PollOptions<T>): Promise<T> {
  const {
    fetchSnapshot,
    hasChanged,
    intervalMs = 2000,
    timeoutMs = 90_000,
    initialSnapshot,
  } = opts;

  let latest = initialSnapshot ?? (await fetchSnapshot());
  if (hasChanged(latest)) return latest;

  const start = Date.now();
  while (Date.now() - start < timeoutMs) {
    await new Promise((r) => setTimeout(r, intervalMs));
    latest = await fetchSnapshot();
    if (hasChanged(latest)) return latest;
  }
  return latest;
}
